import type { CasOrCategory } from '../types/db.ts';

export function casIsValid(cas: string): cas is CasOrCategory {
  if (!/^[1-9]{1}[0-9]{1,6}-\d{2}-\d$/.test(cas)) {
    return false;
  }

  const digits = cas
    .replace(/-/g, '')
    .split('')
    .map((d) => parseInt(d, 10));
  const checkDigit = digits.pop();

  let sum = 0;
  for (let i = digits.length; i > 0; i--) {
    sum += digits.shift()! * i;
  }

  return checkDigit === sum % 10;
}

// Used when we need something to stand in as a non-TRI material. This is intentionally not a valid CAS number:
export const casPlaceholder = '00-00-0' as CasOrCategory;
